import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActionsSharedData } from '../shared/actions-header/actions.shared.data';
import { SubirConformeComponent } from './subir-conforme/subir-conforme.component';
import { BaseUser, UserService } from '@arpada/arp-lib-common-qupro';
import { ConformesFilter, ConformesService, PortalProveedorService, MessagesService } from '../../services/api.services';
import { RestConformesResponse, Conforme, Page, DatatableMessage } from '../../models/api.models';
import { ConformeData } from '../shared/conforme.data';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-conformes',
  templateUrl: './conformes.component.html',
  styleUrls: ['./conformes.component.scss'],
})
export class ConformesComponent implements OnInit {


  conformes: Conforme[];
  conformesData: ConformeData = new ConformeData();

  sharedData: ActionsSharedData = new ActionsSharedData();
  conformesFilter: ConformesFilter = new ConformesFilter();
  filtroConforme = true;
  showList = true;
  showCardList = false;
  showListButton =  false;
  showCardListButton = true;

  totalCountNumber = -1;
  totalCount = '-';
  conformesSelected = -1;
  offsetInfiniteScroll: number;

  uploadAgreementSubscription: Subscription;

  constructor(
    private modalCtrl: ModalController, 
    private messages: MessagesService,
    private portalProveedorService: PortalProveedorService,
    private conformesService: ConformesService,
    private userService: UserService,
    ) {
      this.initFilter();
      this.initConformesData();
      this.initPage();
    }



    ngOnDestroy(): void {
      if (this.uploadAgreementSubscription) {
        this.uploadAgreementSubscription.unsubscribe();
      }
    }

  ngOnInit() {
    this.offsetInfiniteScroll = this.conformesData.page.offset;
    this.uploadAgreementSubscription = this.conformesService.uploadAgreementEvent.subscribe((resp: string) => {
      this.getConformes(this.conformesData.page);
    });

    const modoVista = localStorage.getItem('modoVista');
    this.showModoVista(modoVista);
    this.setTotalCount(-1);
    this.messages.onInitTranslateService().subscribe( () => {
      this.getConformes(this.conformesData.page);
    });
  }

  doInfinite(event) {
    // crearme nueva pagina múltiplo 4 por tema de MD
    const cardPage: Page = new Page();
    cardPage.offset = 0;
    cardPage.limit = 10;
    cardPage.count = 0;
    ++this.offsetInfiniteScroll;
    cardPage.offset = this.offsetInfiniteScroll;
    this.getConformes(cardPage, event, true);
  }

  private getConformes(page: Page, event?, doAppend?: boolean) {
    const start = page.offset * page.limit;
    const limit = page.limit;
    if (!doAppend) {
      this.conformesData.conformes = [];
      this.sharedData.issuesFrontIdsSelected = [];
    }
    this.conformesFilter.limit = limit;
    this.conformesFilter.offset = start;
    this.userService.getLoggedUserDataCached().subscribe((userData: BaseUser) => {
      this.conformesFilter.supplier_partner_id = userData.partner_id;
      this.conformesService.getSupplierConformes(this.conformesFilter).subscribe((conformesResponse: RestConformesResponse) => {
        this.setTotalCount(conformesResponse.count);
        this.conformes = conformesResponse.agreements;
        this.conformesData.page.count = conformesResponse.count;
        if (!doAppend) {
          this.conformesData.conformes = this.conformes;
        } else {
          if (this.conformes != null && this.conformes.length > 0) {
            this.conformes.forEach((conforme: Conforme) => {
              this.conformesData.conformes.push(conforme);
            });
          }
        }
        this.conformesData.loading = false;
        if (event) {
          event.target.complete();
        }
      });
    });
  }

  onFilterChange(filtroRecibido) {
    const filterTemp = new ConformesFilter();
    Object.assign(filterTemp, filtroRecibido);
    this.conformesFilter = filterTemp;
    this.initConformesData();
    this.initPage();
    this.getConformes(this.conformesData.page);
  }

  onListPressed(event: Event) {
    this.showListButton = false;
    this.showCardListButton = true;
    this.showList = true;
    this.showCardList = false;
  }

  onCardListPressed(event: Event) {
    this.showListButton = true;
    this.showCardListButton = false;
    this.showList = false;
    this.showCardList = true;
  }
  onSubirConformePressed(event: Event) {
    this.subirConforme();
  }

  async subirConforme() {
    const modal = await this.modalCtrl.create({
      component: SubirConformeComponent,
      componentProps: {
        isModal: true,
        afterLogin: false
      }
    });
    return await modal.present();
  }

  private showModoVista(modoVista: string) {
    if (modoVista === 'cards') {
      this.onCardListPressed(null);
    }
    if (modoVista === 'escritorio') {
      this.onListPressed(null);
    }
  }

  private setTotalCount(totalCountNumber: number) {
    this.totalCountNumber = totalCountNumber;
    if (totalCountNumber >= 0) {
      this.totalCount = totalCountNumber + '';
      this.sharedData.totalCount = totalCountNumber + '';
    } else {
      this.totalCount = '-';
      this.sharedData.totalCount = '-';
    }
  }

  private initPage() {
    this.conformesData.page.offset = 0;
    this.conformesData.page.limit = 10;  // por defecto, ya que para los distintos tamannos tenemos que calcularlo.
    this.conformesData.page.count = 0;
  }

  private initConformesData() {
    this.conformesData.conformes = [];
    this.conformesData.page = new Page();
    this.conformesData.loading = true;
    this.conformesData.msg = new DatatableMessage();
    this.conformesData.msg.emptyMessage = '';
    this.conformesData.msg.totalMessage = 'total';

  }

  private initFilter() {
    const newFilter: ConformesFilter = new ConformesFilter();
    // Assign all fields to actual filter
    Object.assign(this.conformesFilter, newFilter);
  }
}
